export const titleCodes = {
    
    synergy: {
        code: "${merchantId}_tmpl_title_1",
        title: "Myanmar Synergy Garment"
    },

    clientTitle: {
        code: "${merchantId}_tmpl_title_2",
        title: "Ethical Practice & Technical Audit"
    },

    warehouse: {
        code: "${merchantId}_tmpl_title_7",
        title: "Warehouse"
    },

    pattern: {
        code: "${merchantId}_tmpl_title_8",
        title: "Pattern Room"
    },

    cutting: {
        code: "${merchantId}_tmpl_title_9",
        title: "Cutting"
    },

    sewing: {
        code: "${merchantId}_tmpl_title_10",
        title: "Sewing"
    },

    finishing: {
        code: "${merchantId}_tmpl_title_11",
        title: "Finishing"
    },

    factory: {
        code: "${merchantId}_tmpl_title_15",
        title: "Factory Process"
    },

    getTouch: {
        code: "${merchantId}_tmpl_title_12",
        title: "Get In Touch With Us For Your Brand."
    },
}

export const textCodes = {
    
    est: {
        code: "${merchantId}_tmpl_text_1",
        text: "Established in August 2012"
    },

    about1: {
        code: "${merchantId}_tmpl_text_2",
        text: "JV Cooperation between Korea and Myanmar 50% - 50% operated until 2020 before the COVID 19 Crises hit the garment industry."
    },

    about2: {
        code: "${merchantId}_tmpl_text_3",
        text: "However, we started operating again from November 2021 with the investment of Myanmar Co-founder and become Citizen fully own private company."
    },

    clients: {
        code: "${merchantId}_tmpl_text_4",
        text: "Clients"
    },

    cuttingText: {
        code: "${merchantId}_tmpl_text_9",
        text: "16 Tables running on 1 auto cutter machine."
    },

    contactButton: {
        code: "${merchantId}_tmpl_text_12",
        text: "Contact us"
    },
}


export const imageCodes = {
    
    banner: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbackground.png?alt=media&token=46742746-81b3-4a20-a283-1681d27731fa"
    },

    aboutSynergy: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F20221027_134704%20(1).gif?alt=media&token=08a8e4e6-e013-42de-91c7-ebb42e7aec2a"
    },

    process1: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fwarehouse.jpg?alt=media&token=9fa9533f-b5b9-47cb-9371-a45856df5282"
    },

    process2: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcutting.jpg?alt=media&token=4a59cc2a-c2eb-4c5a-87db-0deb78896de3"
    },

    process3: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpattern.jpg?alt=media&token=3e4461b2-57a3-4eb6-ae28-e9e61e5ee54b"
    },

    process4: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fsewing.jpg?alt=media&token=c4ef3d11-44a8-489a-b8ca-87b945486e30"
    },

    client1: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fclient%20f1.png?alt=media&token=2a442363-8143-49ad-9604-0c22c2efc548"
    },

    client2: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fclient%20f3.png?alt=media&token=65258bde-15df-439f-bae9-7cf24607775e"
    },

    client3: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fclient%20f4.png?alt=media&token=e54f7d18-7085-4a3b-9abe-5ff2925e4e87"
    },

    client5: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fclient%20f2.png?alt=media&token=ed006997-2a3f-46f6-bd3b-bd73039fffda"
    },
   
    process5: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpattern.jpg?alt=media&token=3e4461b2-57a3-4eb6-ae28-e9e61e5ee54b"
    },

}

export const videoCodes = {
    
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/U0hkTDI8TMc"
    },

}
